import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

class CacheEntry {

  public error: any;
  public loading: boolean;
  public sub: Subject<any> = new Subject<any>();

  constructor(public url: string,
              public created: number,
              public data: any) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class HttpCacheClient {

  cache: Map<string, CacheEntry> = new Map();
  loading: boolean = false;

  constructor(private httpClient: HttpClient) {
  }

  load(entry: CacheEntry, params: any = {}) {
    entry.loading = true;
    this.httpClient.get(entry.url, params)
      .subscribe((response: any) => {
        entry.sub.next(response);
        entry.data = response;
        entry.loading = false;
      }, (e) => {
        entry.sub.error(e);
        entry.error = e;
        entry.loading = false;
      });
  }

  get<T extends any>(url: string, params: any = {}, ttl = 60000): Observable<T> {
    let entry = this.cache.get(url);
    if (entry && entry.created < Date.now() - ttl) {
      this.cache.delete(url);
      entry = null;
    }
    if (entry && entry.loading) {
      return entry.sub;
    }
    if (!entry) {
      entry = new CacheEntry(url, Date.now(), null);
      this.cache.set(url, entry);
      this.load(entry, params);
      return entry.sub;
    } else {
      return of(entry.data);
    }
  }
}
